import React from 'react';
import gql from 'graphql-tag';
import GraphQLTable from '../generic/GraphQLTable';
import { Card, Button, Modal, Grid } from '../generic'
import moment from 'moment';
import { useState } from 'react';
import TextField from '@material-ui/core/TextField'
import NewGroup from './NewGroup';

export const getAllGroups = gql`
  {
    groups(limit: 30000) {
      id
      name
      postalCode
      roleHolders {
        role
      }
      consultant {
        id
        first
        last
      }
      products {
        id
        state
        groupProductNumber
        oldGroupProductNumber
        numMembers
        numLivesCovered
        currentPremiumTotal
      }
    }
  }
`

const config = {
  query: getAllGroups,
  dataset: (data) => data.groups,
  fields: {
    name: { label: 'Group Name' },
    consultantName: {
      label: 'Consultant',
      accessor: (row) => (row.consultant ? (`${row.consultant.first} ${row.consultant.last}`) : null)
    },
    numRoleHolders: {
      label: '# Role holders',
      accessor: (row) => (row.roleHolders ? row.roleHolders.length : null)
    },
    'products[0].numMembers': {
      label: '# Members'
    },
    'products[0].numLivesCovered': {
      label: '# Lives Covered'
    },
    'products[0].groupProductNumber': { label: 'Group Product Number' },
    'products[0].oldGroupProductNumber': { label: 'Old Group Product Number' },
    'products[0].currentPremiumTotal': { label: 'Next Premium' },
    postalCode: { label: 'Postal Code' },
    'products[0].state': { label: 'State' }
  },
  defaultSorted: [{ id: 'name' }]
}

const GroupsList = ({history, mode}) => {
  const [open, setOpen] = useState(false);
  
  return (
    <Card>
      {console.log('history is ', history)}
      <h1>
        All Groups
        <Grid>
        <Button style={{ marginRight: '1em', marginTop: 7 }} color="primary" onClick={() => setOpen(true)}>
          Add Group Funeral
        </Button>
        <Button style={{ marginRight: '1em', marginTop: 7 }} color="primary" onClick={() => history.push(`/groups/info-required/list`)} >
          In Progress
        </Button>
        </Grid>
      </h1>
      <NewGroup open={open} setOpen={setOpen} history={history}/>
      <GraphQLTable config={config} onRowPress={(groups) => history.push(`/groups/${groups.id}`)} />
    </Card>
  )
}

export default GroupsList;